
module.exports = {
  EDIT: 'Reading and Editing',
  PRIVATE: 'Only to the owner',
  VIEW: 'Read-only',
};
